/* Language */

document.addEventListener('DOMContentLoaded', function() {
    const langButton = document.getElementById('language-button'); // your button id
    const langMenu = document.getElementById('language-menu');

    if (langButton && langMenu) {
        langButton.addEventListener('click', () => {
            langMenu.classList.toggle('is-open');
            console.log('Language menu toggled, is-open:', langMenu.classList.contains('is-open'));
        });
    }
});

